import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { fmtAud } from "../lib/format";

export default function Pipeline() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [f, setF] = useState({ segment:"", status:"", rep_id:"" });
  const [users, setUsers] = useState([]);
  const [stacked, setStacked] = useState(true);

  const reload = useCallback(async () => {
    const p = new URLSearchParams();
    for (const [k, v] of Object.entries(f)) if (v) p.set(k, v);
    const { data } = await api.get(`/pipeline?${p}`);
    setData(data);
  }, [f]);
  useEffect(() => { reload(); }, [reload]);
  useEffect(() => { api.get("/users").then(r => setUsers(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-4" data-testid="pipeline-page">
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-bold">12-Month FY Pipeline</h1>
          <p className="text-sm text-gray-500">{user?.role === "admin" ? "Showing all reps" : "Your pipeline"}</p>
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={stacked} onChange={e=>setStacked(e.target.checked)} data-testid="pipeline-stacked-toggle"/>
          Stacked by status
        </label>
      </div>
      <div className="cesco-card p-4 grid grid-cols-2 md:grid-cols-4 gap-3">
        <select className="cesco-input" value={f.segment} onChange={e=>setF({...f, segment:e.target.value})}
                data-testid="pipeline-filter-segment">
          <option value="">All segments</option><option value="D">Drill</option><option value="M">Mixer</option>
        </select>
        <select className="cesco-input" value={f.status} onChange={e=>setF({...f, status:e.target.value})}>
          <option value="">All statuses</option><option value="OPEN">Open</option><option value="WON">Won</option><option value="LOST">Lost</option>
        </select>
        {user?.role === "admin" && (
          <select className="cesco-input" value={f.rep_id} onChange={e=>setF({...f, rep_id:e.target.value})}>
            <option value="">Any rep</option>
            {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
        )}
      </div>
      <div className="cesco-card p-4" style={{ height: 460 }}>
        {!data ? <div className="skeleton h-full w-full"/> : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data.months}>
              <CartesianGrid stroke="#eee"/>
              <XAxis dataKey="label" tick={{ fontSize: 11 }}/>
              <YAxis tickFormatter={v => fmtAud(v)} tick={{ fontSize: 11 }} width={80}/>
              <Tooltip formatter={(v, name, item) => {
                const st = (item?.dataKey || "").toString();
                const c = item?.payload?.[`${st}_count`];
                return [`${fmtAud(v)}${c != null ? ` · ${c} deal${c === 1 ? "" : "s"}` : ""}`, name];
              }}/>
              <Legend/>
              <Bar dataKey="open" name={`Open (${data.totals?.open ?? 0})`} stackId={stacked ? "s" : undefined} fill="#4A90E2"/>
              <Bar dataKey="won"  name={`Won (${data.totals?.won ?? 0})`}   stackId={stacked ? "s" : undefined} fill="#2ECC71"/>
              <Bar dataKey="lost" name={`Lost (${data.totals?.lost ?? 0})`} stackId={stacked ? "s" : undefined} fill="#E74C3C"/>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
